import { render, staticRenderFns } from "./PickTopic.vue?vue&type=template&id=8571224c&"
import script from "./PickTopic.vue?vue&type=script&lang=js&"
export * from "./PickTopic.vue?vue&type=script&lang=js&"
import style0 from "./PickTopic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports